
export default {
  name: 'BaseInput',
  inheritAttrs: false,
  data() {
    return {
      focused: false,
      value: '',
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        focus: this.onFocus,
        blur: this.onBlur,
      }
    },
    slotData() {
      return {
        ...this.listeners,
        focused: this.focused,
      }
    },
  },
  watch: {
    value(newValue) {
      this.$emit('input', this.value)
    },
  },
  methods: {
    onFocus(value) {
      this.focused = true
      this.$emit('focus', value)
    },
    onBlur(value) {
      this.focused = false
      this.$emit('blur', value)
    },
  },
}
